import range from 'lodash-es/range';
import truncate from 'lodash-es/truncate';
import { upperCaseFirst } from 'mk/bazaar/common/filters';
import { MicroPostEntity } from 'mk2/apps/forum/schemas';
import * as forumUrls from 'mk2/apps/forum/urls';
import LinkListItem, { GrowPriority, LinkListItemPlaceholder } from 'mk2/components/LinkListItem';
import Panel from 'mk2/components/Panel';
import PanelHeading from 'mk2/components/PanelHeading';
import { url } from 'mk2/helpers/urls';
import * as React from 'react';
import styles from './MorePosts.mscss';

interface OwnProps {
    className?: string;
    posts: MicroPostEntity[];
    topicSlug: string;
    title: string;
    showComments?: boolean;
}

export const MorePosts: React.FunctionComponent<OwnProps> = React.memo(({ className, posts, topicSlug, title, showComments = true }) => (
    posts && posts.length > 0 ? (
        <Panel className={className}>
            <PanelHeading title={title} />
            <ul className={styles.MorePosts__posts}>
                {posts.map((post, idx) => (
                    <LinkListItem
                        key={post.id}
                        to={url(forumUrls.forumPostDetail, {topicSlug, postSlug: post.slug})}
                        title={upperCaseFirst(truncate(post.heading, { length: 80 }))}
                        priority={GrowPriority.subtitle}
                    >
                        {showComments && (
                            <>
                                <i className="fa fa-commenting-o" />
                                {post.comments}
                            </>
                        )}
                    </LinkListItem>
                ))}
            </ul>
        </Panel>
    ) : null
));

interface PlaceholderOwnProps {
    className?: string;
    title: string | React.ReactNode;
}

export const MorePostsPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = React.memo(({ className, title }) => (
    <Panel className={className}>
        <PanelHeading title={title} />

        <ul className={styles.MorePosts__posts}>
            {range(6).map((idx) => (
                <LinkListItemPlaceholder key={idx} width={`${ [90, 85, 80, 70, 75, 85][idx % 6] }%`} />
            ))}
        </ul>
    </Panel>
));
